export function suggestedTicketQty(billing) {
  if (!billing || Array.isArray(billing)) return null;
  const raw = billing.default_qty;
  if (raw == null || raw === '') return null;
  const qty = Number(raw);
  return Number.isFinite(qty) ? qty : null;
}
